const reducers = {
  showSnackBar(state, action) {
    state.isOpen = action.payload ?? true;
  },
  hideSnackBar(state) {
    state.isOpen = false;
  },
  setMessage(state, action) {
    const { message } = action.payload;
    state.message = message;
  },
  setSeverity(state, action) {
    const { severity } = action.payload;
    state.severity = severity;
  }
}

export default reducers;
